export default "__VITE_ASSET__B5jc7jQz__"